import React, { useEffect, useState } from 'react';
import { Users, Mic, CreditCard, ShoppingBag, FileCheck } from 'lucide-react';
import { useSupabase } from '../hooks/useSupabase';
import { aicisAPI } from '../services/api';
import StatsCard from '../components/Dashboard/StatsCard';
import RecentActivity from '../components/Dashboard/RecentActivity';
import { LineChartWidget, PieChartWidget } from '../components/Dashboard/ChartWidget';


export default function AicisDashboard() {
  const [stats, setStats] = useState(null);
  const { data: signIns } = useSupabase(aicisAPI.getDiplomaticSignIns);
  // eslint-disable-next-line no-unused-vars
  const { data: speakers } = useSupabase(aicisAPI.getSpeakers);
  // eslint-disable-next-line no-unused-vars
  const { data: transactions } = useSupabase(aicisAPI.getEventRegistrations);

  useEffect(() => {
    const loadStats = async () => {
      const statsData = await aicisAPI.getDashboardStats();
      setStats(statsData);
    };
    loadStats();
  }, []);

  // Prepare chart data
  const statusData = [
    { name: 'Pending', value: stats?.pendingSignIns || 0 },
    { name: 'Approved', value: (stats?.totalSignIns || 0) - (stats?.pendingSignIns || 0) },
  ];

  // eslint-disable-next-line no-unused-vars
  const speakerStatusData = [
    { name: 'Pending', value: stats?.pendingSpeakers || 0 },
    { name: 'Approved', value: (stats?.totalSpeakers || 0) - (stats?.pendingSpeakers || 0) },
  ];

  const weeklyData = [
    { day: 'Mon', registrations: 12 },
    { day: 'Tue', registrations: 19 },
    { day: 'Wed', registrations: 15 },
    { day: 'Thu', registrations: 22 },
    { day: 'Fri', registrations: 18 },
    { day: 'Sat', registrations: 8 },
    { day: 'Sun', registrations: 5 },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">AICIS Nigeria 2026 Dashboard</h1>
        <p className="text-gray-600">Overview of all conference activities</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">
        <StatsCard
          title="Diplomatic Sign Ins"
          value={stats?.totalSignIns || 0}
          icon={Users}
          color="primary"
          subtitle={`${stats?.pendingSignIns || 0} pending`}
        />
        <StatsCard
          title="Speakers"
          value={stats?.totalSpeakers || 0}
          icon={Mic}
          color="secondary"
          subtitle={`${stats?.pendingSpeakers || 0} pending`}
        />
        <StatsCard
          title="Event Registrations"
          value={stats?.totalTransactions || 0}
          icon={CreditCard}
          color="green"
          subtitle={`${stats?.pendingTransactions || 0} pending`}
        />
        <StatsCard
          title="Affiliate Purchases"
          value={stats?.totalPurchases || 0}
          icon={ShoppingBag}
          color="blue"
          subtitle={`${stats?.pendingPurchases || 0} pending`}
        />
        <StatsCard
          title="Policy Agreements"
          value={stats?.totalAgreements || 0}
          icon={FileCheck}
          color="purple"
        />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-2">
          <LineChartWidget
            data={weeklyData}
            dataKey="registrations"
            xAxisKey="day"
            title="Weekly Sign Ins"
            color="#c53030"
          />
        </div>
        <div>
          <PieChartWidget
            data={statusData}
            title="Sign In Status"
          />
        </div>
      </div>

      {/* Recent Activity */}
      <RecentActivity 
        data={signIns?.slice(0, 5) || []} 
        title="Recent Diplomatic Sign Ins"
      />
    </div>
  );
}